import React, { useState, useEffect } from "react";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import {useLocalStorage} from "../../../../utils";

export function Logout() {
  const [logout, setLogout] = useState(false);
  const [localStorageData, setLocalStorageData] = useLocalStorage("clientpanel");

  useEffect(() => {
    setLogout(true);
    setLocalStorageData(null);
    window.location.replace("/login");
  }, []);

  return logout ? <Redirect to="/login" /> : <LayoutSplashScreen /> ;
}
